import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger } from 'react-bootstrap';

import ProjectViewModal from './ProjectViewModal';
import DayViewModal from './DayViewModal';
import RejectModal from './RejectModal';
import DetailsPopover from './DetailsPopover';

import * as logEntryActions from '../actions/logEntryActionCreators';

class ApprovedHourItem extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showProjectsModal: false,
            showDaysModal: false,
            showRejectModal: false,
            justApproved: false,
            shouldApprove: this.props.shouldApprove
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        /*this.props.dispatch(logEntryActions.loadByTimesheet(this.props.timesheetID));
        this.props.dispatch(logEntryActions.loadByTimesheetTasks(this.props.timesheetID));*/
    }

    // EVENT HANDLERS

    handleApprove = () => {
        this.props.handleApprove(this.props.approvedHoursID, this.props.timesheetID, this.props.projectKey, this.props.taskKey, this.props.approvedHourKey);
        this.setState({
            shouldApprove: false,
            justApproved: true
        });
    }

    handleCloseDayModal = () => {
        this.setState({
            showDaysModal: false
        });
    }

    handleCloseProjectModal = () => {
        this.setState({
            showProjectsModal: false
        });
    }

    handleCloseRejectModal = () => {
        this.setState({
            showRejectModal: false
        });
    }

    // TODO this.props.rejectMessage might be useless
    handleConfirmReject = (message) => {
        this.props.handleReject(this.props.timesheetID, this.props.approvedHoursID, message, this.props.projectKey, this.props.taskKey);
        this.handleCloseRejectModal();
    }

    handleDayDetailsClick = () => {
        this.props.dispatch(logEntryActions.loadByTimesheet(this.props.timesheetID));
        this.setState({
            showDaysModal: true
        });
    }

    handleProjectDetailsClick = () => {
        this.props.dispatch(logEntryActions.loadByTimesheetTasks(this.props.timesheetID));
        this.setState({
            showProjectsModal: true
        });
    }

    handleRejectClick = () => {
        this.setState({
            showRejectModal: true
        });
    }

    // OTHER METHODS

    // RENDER METHOD

    render = () => {

        let dayModal = <DayViewModal
                           color={this.props.color}
                           handleClose={this.handleCloseDayModal}
                           projectName={this.props.projectName}
                           task={this.props.task}
                           timesheetID={this.props.timesheetID}
                           usersName={this.props.usersName}
                           />;
        let projectModal = <ProjectViewModal
                               color={this.props.color}
                               date={this.props.date}
                               handleClose={this.handleCloseProjectModal}
                               projectNames={this.props.projectNames}
                               projectName={this.props.projectName}
                               shouldApprove={this.props.shouldApprove}
                               usersName={this.props.usersName}
                               />;
        let rejectModal = <RejectModal
                              handleConfirm={this.handleConfirmReject}
                              handleClose={this.handleCloseRejectModal}
                              />;

        let rejectionDate = this.props.rejectedAt ? this.props.rejectedAt.split("T")[0] : "";
        let popover = <DetailsPopover
                          formattedPrevOvertimeRejected={this.props.formattedOvertimePrevRejected}
                          formattedPrevRejected={this.props.formattedRegularTimePrevRejected}
                          message={this.props.rejectMessage}
                          rejected={rejectionDate}
                          />;

        if (this.props.status === "ENTRY") {
            return (
                <tr className="not-submitted">
                    <td>
                        {this.state.showDaysModal ? dayModal : null}
                        {this.state.showProjectsModal? projectModal: null}
                        <a
                            onClick={this.handleProjectDetailsClick}
                            style={{"cursor" : "pointer"}}
                            className="popover-trigger"
                            tabIndex="0"
                            data-toggle="popover"
                            data-trigger="focus"
                            title="Popover Person-Projects - vidi na dnu stranice"
                            data-content="Popis projekata i broj sati po projektu koje je osoba upisala u kalendar taj tjedan">
                            <span data-toggle="tooltip" data-placement="top" title="User work logged this week by tasks">
                                {this.props.usersName}
                            </span>
                        </a>
                    </td>
                    <td className="text-center">
                        <a
                            onClick={this.handleDayDetailsClick}
                            style={{"cursor" : "pointer"}}
                            className="popover-trigger"
                            tabIndex="0"
                            data-toggle="popover"
                            data-trigger="focus"
                            title="Popover Person-Calendar - vidi na dnu stranice"
                            data-content="Prikaz log-entryja po danima + description">
                            <span  data-toggle="tooltip" data-placement="top" title="Work logged on task by days">
                                <strong>{this.props.formattedRegularTime}</strong> (+ {this.props.formattedOvertime})
                            </span>
                        </a>
                    </td>
                    {
                       this.props.timePrevRejected && this.props.timeApproved !== this.props.timeTotal &&  this.props.timePrevRejected !== 0
                           ? <td className="text-right">
                               <OverlayTrigger trigger="hover" ref="popoverTrigger" placement="left" delay={250} overlay={popover}>
                                   <span className=" md-report tooltip-trigger" data-toggle="tooltip" data-placement="top">
                                   </span>
                               </OverlayTrigger>
                             </td>
                           :
                           <td className="text-right">
                                <span>
                                        <a className="icon-btn" style={{"background" : "transparent", "border" : "none"}}><span data-toggle="tooltip" data-placement="top"><span></span></span></a>
                                        <a className="icon-btn" style={{"background" : "transparent", "border" : "none"}}><span data-toggle="tooltip" data-placement="top" title="Hours have not been submitted yet"><span>E</span></span></a>
                                </span>
                           </td>
                    }
                </tr>
            );
        }

        if (this.props.status === "APPROVED") {
            return (
                <tr>
                    <td>
                        {this.state.showDaysModal ? dayModal : null}
                        {this.state.showProjectsModal ? projectModal: null}
                        <a
                            title="User work logged this week by tasks"
                            onClick={this.handleProjectDetailsClick}
                            style={{"cursor" : "pointer"}}>
                            {this.props.usersName}
                        </a>
                    </td>
                    <td className="text-center">
                        <a
                            title="Work logged on task by days"
                            onClick={this.handleDayDetailsClick}
                            style={{"cursor" : "pointer"}}>
                            <strong>{this.props.formattedRegularTime}</strong> (+ {this.props.formattedOvertime})
                        </a>
                    </td>
                    <td className="text-right">
                        <span
                            className="md-done-all"
                            data-toggle="tooltip"
                            data-placement="left"
                            title={this.props.approvedBy
                                ? "Approved by: " + this.props.approvedBy + (this.props.pmoApproved
                                                                                           ? (" and " + this.props.pmoApprovers)
                                                                                           : "")
                                : (this.props.pmoApproved
                                    ? ("Approved by " + this.props.pmoApprovers)
                                    : "Approved by: " + this.props.currentUser.givenName + " " + this.props.currentUser.surname)}>
                        </span>
                    </td>
                </tr>
            );
        }

        if (this.props.status === "SUBMITTED" || this.props.status === "FIXING") {
            let parsedMessage = "";
            if (this.props.rejectMessage) {
                let messageTokens = this.props.rejectMessage.split(":");

                for (let i = 1; i < messageTokens.length; i++) {
                    parsedMessage += messageTokens[i];
                    if (i < messageTokens.length - 1) {
                        parsedMessage += ":";
                    }
                }
                parsedMessage = parsedMessage.trim();
            }


            return (
                <tr>
                    <td>
                        {this.state.showRejectModal ? rejectModal : null}
                        {this.state.showDaysModal ? dayModal : null}
                        {this.state.showProjectsModal ? projectModal: null}
                        <a
                            onClick={this.handleProjectDetailsClick}
                            style={{"cursor" : "pointer"}}
                            className="popover-trigger"
                            tabIndex="0"
                            data-toggle="popover"
                            data-trigger="focus"
                            title="Popover Person-Projects - vidi na dnu stranice"
                            data-content="Popis projekata i broj sati po projektu koje je osoba upisala u kalendar taj tjedan">
                            <span data-toggle="tooltip" data-placement="top" title="User work logged this week by tasks">
                                {this.props.usersName}
                            </span>
                        </a>
                    </td>
                    <td className="text-center">
                        <a
                            onClick={this.handleDayDetailsClick} style={{"cursor" : "pointer"}}
                            className="popover-trigger"
                            tabIndex="0"
                            data-toggle="popover"
                            data-trigger="focus"
                            title="Popover Person-Calendar - vidi na dnu stranice"
                            data-content="Prikaz log-entryja po danima + description">
                            <span data-toggle="tooltip" data-placement="top" title="Work logged on task by days">
                                <strong>{this.props.formattedRegularTime}</strong> (+ {this.props.formattedOvertime})
                            </span>
                        </a>
                        {
                            (this.props.timePrevRejected && this.props.timePrevRejected !== 0 || this.props.overtimePrevRejected && this.props.overtimePrevRejected !== 0) && (this.props.timeApproved !== this.props.timeTotal || this.props.overtimeApproved !== this.props.timeOvertime) && !this.props.approvable
                                ? <span
                                        className="status-info md-report tooltip-trigger"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={"Previously rejected: " + this.props.formattedRegularTimePrevRejected + (this.props.formattedOvertimePrevRejected ? " + " + this.props.formattedOvertimePrevRejected : "") + " with message: \"" + parsedMessage + "\""}>
                                </span>
                                : null
                        }
                        {
                            (this.props.timePrevApproved && this.props.timePrevApproved !== 0 || this.props.overtimePrevApproved && this.props.overtimePrevApproved !== 0) && (this.props.timePrevApproved !== this.props.timeTotal || this.props.overtimeApproved !== this.props.timeOvertime)
                                ? <span
                                        className="status-info md-report tooltip-trigger"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={"Previously approved: " + this.props.formattedPrevApproved + (this.props.formattedPrevOvertimeApproved ? " + " + this.props.formattedPrevOvertimeApproved : "")}>
                                </span>
                                : null
                        }
                    </td>
                    {
                        this.props.timeTotal === 0 && this.props.timeOvertime === 0
                            ? null
                            : (this.props.timeApproved !== this.props.timeTotal || this.props.overtimeApproved !== this.props.timeOvertime) && !this.state.justApproved
                                ? <td className="text-right">
                                    {
                                        this.props.status === "FIXING" && !this.props.approvable && ( this.props.timePrevRejected > 0 || this.props.overtimePrevRejected > 0 ) ?
                                        (
                                            <span>
                                                <a className="icon-btn" style={{"background" : "transparent", "border" : "none"}}><span data-toggle="tooltip" data-placement="top"><span></span></span></a>
                                                <a className="icon-btn" style={{"background" : "transparent", "border" : "none"}}><span data-toggle="tooltip" data-placement="top" title={"Rejected at " + this.props.rejectedAt}><span>x</span></span></a>
                                            </span>
                                        )
                                        : this.state.shouldApprove ?
                                        (
                                            <span>
                                                <a className="icon-btn" onClick={this.handleRejectClick} data-toggle="modal" data-target="#myModal5">
                                                    <span data-toggle="tooltip" data-placement="top" title="Reject">
                                                        <span className="md-clear">
                                                        </span>
                                                    </span>
                                                </a>
                                                <a className="icon-btn" onClick={this.handleApprove} >
                                                    <span data-toggle="tooltip" data-placement="top" title="Approve">
                                                        <span className="md-done">
                                                        </span>
                                                    </span>
                                                </a>
                                            </span>
                                        ) : null
                                    }
                                </td>
                                :
                                <td className="text-right">
                                    <span
                                        className="md-done-all"
                                        data-toggle="tooltip"
                                        data-placement="left"
                                        title={this.props.approvedBy
                                            ? "Approved by: " + this.props.approvedBy + (this.props.pmoApproved
                                                                                                       ? (" and " + this.props.pmoApprovers)
                                                                                                       : "")
                                            : (this.props.pmoApproved
                                               ? ("Approved by " + this.props.pmoApprovers)
                                               : "Approved by: " + this.props.currentUser.givenName + " " + this.props.currentUser.surname)}>
                                    </span>
                                </td>
                    }

                </tr>
            );
        }
    }
}

ApprovedHourItem.propTypes = {
   approvable: PropTypes.bool,
   approvedBy: PropTypes.string,
   approvedHours: PropTypes.array,
   approvedHoursID: PropTypes.number,
   approvedHourKey: PropTypes.number,
   color: PropTypes.string,
   currentUser: PropTypes.object,
   date: PropTypes.object,
   dispatch: PropTypes.func,
   formattedPrevApproved: PropTypes.string,
   formattedPrevOvertimeApproved: PropTypes.string,
   formattedRegularTime: PropTypes.string,
   formattedRegularTimePrevRejected: PropTypes.string,
   formattedOvertimePrevRejected: PropTypes.string,
   formattedOvertime: PropTypes.string,
   handleApprove: PropTypes.func,
   handleReject: PropTypes.func,
   overtimeApproved: PropTypes.number,
   overtimePrevApproved: PropTypes.number,
   overtimePrevRejected: PropTypes.number,
   pmoApproved: PropTypes.bool,
   pmoApprovers: PropTypes.array,
   projectNames: PropTypes.array,
   projectName: PropTypes.string,
   projectKey: PropTypes.number,
   rejectedAt: PropTypes.string,
   rejectMessage: PropTypes.string,
   shouldApprove: PropTypes.bool,
   status: PropTypes.string,
   task: PropTypes.object,
   taskKey: PropTypes.number,
   timesheetID: PropTypes.number,
   timeApproved: PropTypes.number,
   timeOvertime: PropTypes.number,
   timeTotal: PropTypes.number,
   timePrevApproved: PropTypes.number,
   timePrevRejected: PropTypes.number,
   usersName: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApprovedHourItem);



/** WEBPACK FOOTER **
 ** ./src/app/components/ApprovedHourItem.js
 **/